import * as React from 'react';
const SvgRegenerateQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#581845"
      d="M6 6.523a.158.158 0 0 0 .16.165h.55c.092 0 .166-.076.178-.167.06-.437.36-.756.894-.756.457 0 .875.229.875.779 0 .423-.25.617-.643.913-.448.326-.803.706-.778 1.324l.002.144a.167.167 0 0 0 .167.164h.54a.167.167 0 0 0 .166-.166v-.07c0-.479.182-.618.673-.99.406-.309.83-.651.83-1.37C9.613 5.486 8.762 5 7.831 5 6.988 5 6.063 5.393 6 6.523Zm1.037 3.84c0 .354.284.617.673.617.406 0 .685-.263.685-.618 0-.367-.28-.626-.685-.626-.39 0-.673.259-.673.626Z"
    />
    <path
      stroke="#581845"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M14.675 6.97A6.923 6.923 0 0 0 1.428 5.26M1 1.843V5.26h3.419M1 8.68a6.924 6.924 0 0 0 13.248 1.71m.428 3.418v-3.419h-3.42"
    />
  </svg>
);
export default SvgRegenerateQuestion;
